export const ImageMoudel = {
  methods: {
    // 图片下载
    downloadIamge (link, picName) { // 下载图片地址和图片名
      const img = new Image()
      img.setAttribute('crossOrigin', 'Anonymous')
      img.onload = function () {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        context.drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob(blob => {
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          const event = new MouseEvent('click')
          a.download = picName || 'default.png'
          a.href = url
          a.dispatchEvent(event)
          URL.revokeObjectURL(url)
        })
      }
      img.src = link + '?v=' + Date.now()
    }
  }
}
